// src/data/gyms/StTeresas.js
export const StTeresas = {
  id: "stteresas",
  name: "St Teresa's Cath Athletic League",
  color: "#B91C1C", // Deep Red
  lightColor: "#FEF2F2",
  logo: "⛪️",

  teams: [
    {
      id: "eagles",
      name: "St. Teresa's Eagles",
      level: "L1 - Rec Performance Advanced - 14Y",
    },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "8:10 AM", // Floor compete
      teamId: "eagles",
      meet: "7:34 AM", // Check-in
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // Rec teams only compete one day.
  ],
};
